import BigNumber from 'bignumber.js';

import { getClosePositionFee } from './getClosePositionFee';
/**
 * pnlAfterFee = pnl - fundingFee - closeFee - holdingFee
 * liang note:
      fundingFeeRaw > 0 , means the position earning funding fee.
      fundingFeeRaw < 0 , means the position paying funding fee.
      after fee not involving open/exec fee because is already deducted from user payment, should no longer care about these 2 fee when position is opened
      this fundingFee from SC, FE will multiplied -1
 * all in usd
 */
export const getPositionPnlAfterFee = ({
  pnl,
  holdingFee,
  closeFee,
  fundingFee,
}: {
  pnl: BigNumber;
  holdingFee: BigNumber;
  closeFee: ReturnType<typeof getClosePositionFee>;
  fundingFee: BigNumber;
}): BigNumber => {
  return pnl.minus(fundingFee).minus(holdingFee).minus(closeFee.finalCloseFee);
};
